'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var StarCircle = function (_BaseIcon) {
  (0, _inherits3.default)(StarCircle, _BaseIcon);

  function StarCircle() {
    (0, _classCallCheck3.default)(this, StarCircle);
    return (0, _possibleConstructorReturn3.default)(this, (StarCircle.__proto__ || (0, _getPrototypeOf2.default)(StarCircle)).apply(this, arguments));
  }

  (0, _createClass3.default)(StarCircle, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M23 28c4.9705627 0 9-4.0294373 9-9 0-4.97056275-4.0294373-9-9-9-4.97056275 0-9 4.02943725-9 9 0 4.9705627 4.02943725 9 9 9zm0-6l-3.5267115 1.854102.67354195-3.92705102-2.85316955-2.78115295 3.94298334-.572949L23 13l1.7633558 3.57294902 3.9429833.572949-2.8531696 2.78115296.673542 3.92705102L23 22z'
        }, this.getPathProps()))
      );
    }
  }]);
  return StarCircle;
}(_BaseIcon3.default);
/*eslint-enable */


StarCircle.defaultProps = {
  width: 18,
  height: 18,
  viewBox: '14 10 18 18'
};
exports.default = StarCircle;
//# sourceMappingURL=StarCircle.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/StarCircle.js
// module id = 325
// module chunks = 0